module.exports = __webpack_public_path__ + "media/slot-game/euro-c26e4610.svg";